'use strict';

angular.module('atex.dam').controller('DamLeftSideAnimation', ['$scope', '$rootScope','$window',
function($scope, $rootScope,$window) {
  $scope.toggle ="";
  $scope.staticc="visible-lg col-lg-2";
 
  $scope.$on('dam:toggle', function(event) {
	  $scope.toggle  = ($scope.toggle === "") ? "menu":"";
	  $scope.staticc = ($scope.staticc === "visible-lg col-lg-2") ? "menu-toggle" : "visible-lg col-lg-2";
  });
  
  $scope.$on('dam:hide-menu', function(event) {
    $scope.toggle  = "";
    $scope.staticc = "visible-lg col-lg-2";
  });
  
  var win = angular.element($window);
  win.bind("resize",function(e){
	  var h = $window.innerWidth;
	  if(h>=1200) {
		  $scope.toggle  = "";
		  $scope.staticc = "visible-lg col-lg-2";
		  $scope.$apply();
		  
		  $rootScope.$broadcast('dam:reset-toggle');
	  }
  });
}]);
